import { CheckButtonRow, type CheckButtonRowProps } from "./CheckButtonRow";

const months = "Jan Feb Mar Apr May Jun Jul Aug Sep Oct Nov Dec".split(" ");

export interface MonthPickerProps
  extends Omit<CheckButtonRowProps, "buttonLabels"> {}

export const MonthPicker = ({ id, ...props }: MonthPickerProps) => {
  return <CheckButtonRow id={id} {...props} buttonLabels={months} />;
};
